import * as React from 'react';

import styles from './feedback-form-wrapper.module.css';

type Props = {
    children: React.ReactNode;
    onSubmit: (e: React.SyntheticEvent<HTMLFormElement>) => void;
};

export function FeedbackFormWrapper(props: Props) {
    return (
        <form onSubmit={props.onSubmit} className={styles['feedback-form']}>
            {props.children}
        </form>
    );
}
